import { createSlice } from '@reduxjs/toolkit';

import { getLessonListByCategoryIdAction } from '@/Module/HomePage/Store/Action';
import { categoryLessonSectionListAdapter } from '@/Module/HomePage/Store/Adapter';
import { lessonSectionAdapter } from '@/Module/Lesson/Store/Adapter';

const initialState = categoryLessonSectionListAdapter.setAll(
  categoryLessonSectionListAdapter.getInitialState({
    isLoading: false,
  }),
  [
    {
      category: {
        title: 'تیزهوشان',
        id: '52',
      },
      isLoading: false,
      lessonSectionList: lessonSectionAdapter.getInitialState(),
    },
    {
      category: {
        title: 'کنکور',
        id: '44',
      },
      isLoading: false,

      lessonSectionList: lessonSectionAdapter.getInitialState(),
    },
    {
      category: {
        title: 'دوازدهم',
        id: '28',
      },
      isLoading: false,
      lessonSectionList: lessonSectionAdapter.getInitialState(),
    },

    {
      category: {
        title: 'یازدهم',
        id: '25',
      },
      isLoading: false,
      lessonSectionList: lessonSectionAdapter.getInitialState(),
    },
    {
      category: {
        title: 'دهم',
        id: '22',
      },
      isLoading: false,
      lessonSectionList: lessonSectionAdapter.getInitialState(),
    },
    {
      category: {
        title: 'نهم',
        id: '21',
      },
      isLoading: false,
      lessonSectionList: lessonSectionAdapter.getInitialState(),
    },
    {
      category: {
        title: 'هشتم',
        id: '20',
      },
      isLoading: false,
      lessonSectionList: lessonSectionAdapter.getInitialState(),
    },
    {
      category: {
        title: 'هفتم',
        id: '19',
      },
      isLoading: false,
      lessonSectionList: lessonSectionAdapter.getInitialState(),
    },

    {
      category: {
        title: 'ششم',
        id: '18',
      },
      isLoading: false,
      lessonSectionList: lessonSectionAdapter.getInitialState(),
    },

    {
      category: {
        title: 'پنجم',
        id: '17',
      },
      isLoading: false,
      lessonSectionList: lessonSectionAdapter.getInitialState(),
    },
    {
      category: {
        title: 'چهارم',
        id: '16',
      },
      isLoading: false,
      lessonSectionList: lessonSectionAdapter.getInitialState(),
    },
    {
      category: {
        title: 'سوم',
        id: '15',
      },
      isLoading: false,
      lessonSectionList: lessonSectionAdapter.getInitialState(),
    },
    {
      category: {
        title: 'دوم',
        id: '14',
      },
      isLoading: false,
      lessonSectionList: lessonSectionAdapter.getInitialState(),
    },
    {
      category: {
        title: 'اول',
        id: '13',
      },
      isLoading: false,
      lessonSectionList: lessonSectionAdapter.getInitialState(),
    },
    {
      category: {
        title: 'امتحان نهایی',
        id: '65',
      },
      isLoading: false,
      lessonSectionList: lessonSectionAdapter.getInitialState(),
    },
  ],
);

const CategoryLessonSectionListSlice = createSlice({
  name: 'categoryLessonSectionList',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getLessonListByCategoryIdAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getLessonListByCategoryIdAction.rejected, state => {
        state.isLoading = true;
      })
      .addCase(getLessonListByCategoryIdAction.fulfilled, (state, { payload, meta }) => {
        state.isLoading = false;
        const category = state.entities[meta.arg.categoryCategoryId]!;
        lessonSectionAdapter.setAll(category.lessonSectionList, payload.data);
      });
  },
});

export default CategoryLessonSectionListSlice;
